// Añadir declaración de tipos para import.meta.env
interface ImportMetaEnv {
  VITE_YOUTUBE_API_KEY?: string;
  VITE_GOOGLE_API_KEY?: string;
  VITE_GOOGLE_CLIENT_ID?: string;
  VITE_SUPABASE_ANON_KEY?: string;
  DEV?: boolean;
  PROD?: boolean;
}

interface ImportMeta {
  env: ImportMetaEnv;
}

// Acceder a las variables de entorno de manera segura
const getEnvVar = (name: string): string => {
  // @ts-ignore - Ignorar errores de TypeScript para acceder a import.meta.env
  return (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[name]) || '';
};

// Determinar automáticamente el entorno
// @ts-ignore - Ignorar error de linter
const isDevelopment = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV) || 
                      window.location.hostname === 'localhost';

// Determinar si la aplicación se está ejecutando en un contexto seguro (HTTPS)
const isSecureContext = window.location.protocol === 'https:';

// WebSocket URL y API URL
let wsUrl, apiUrl;

if (isDevelopment) {
  // Entorno de desarrollo
  wsUrl = 'http://localhost:3000';
  apiUrl = 'http://localhost:3000';
} else {
  // Entorno de producción - usar siempre URLs específicas para evitar problemas de conexión
  // Cambiamos de WSS a HTTP para evitar problemas de conexión en producción
  wsUrl = 'https://towatch-backend.onrender.com';
  apiUrl = 'https://towatch-backend.onrender.com';
}

// Determinar el origen actual para CORS
const currentOrigin = window.location.origin;

console.log('Config loaded:', { 
  apiUrl, 
  wsUrl, 
  isDevelopment, 
  isSecureContext,
  currentOrigin
});

const config = {
  apiUrl,
  wsUrl,
  currentOrigin,
  socketOptions: {
    reconnectionAttempts: 3,
    reconnectionDelay: 1000,
    transports: ['polling', 'websocket'], // Cambiado: primero polling, luego websocket
    timeout: 10000,
    withCredentials: false,
    forceNew: true,
    autoConnect: false,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0.5,
    path: '/socket.io/', // Asegurar que el path sea correcto
    secure: isSecureContext,
    rejectUnauthorized: false // Para evitar problemas con certificados SSL
  },
  youtubeApiKey: getEnvVar('VITE_YOUTUBE_API_KEY'),
  googleApiKey: getEnvVar('VITE_GOOGLE_API_KEY'),
  googleClientId: getEnvVar('VITE_GOOGLE_CLIENT_ID'),
  isDev: getEnvVar('DEV') === 'true',
  isProd: getEnvVar('PROD') === 'true'
};

export default config; 